import { useUiLanguage } from "@/i18n/useUiLanguage";
import { systemText, tr } from "@/i18n/copy";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { GOOGLE_ATTEMPT, googleRegistrationKey } from "@/googleAuth";
import { serviceJourneyUrl } from "@/serviceTypes";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  useUiLanguage();
  const { googleExchange } = useAuth();
  const nav = useNavigate();
  const ran = useRef(false);
  const [error, setError] = useState("");
  const [back, setBack] = useState("/login");
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      const params = new URLSearchParams(window.location.hash.slice(1));
      window.history.replaceState(null, "", window.location.pathname);
      const attempt = JSON.parse(sessionStorage.getItem(GOOGLE_ATTEMPT) || "null");
      const slug = attempt?.studioSlug || "";
      setBack(slug ? `/studio/${encodeURIComponent(slug)}/login` : "/login");
      if (params.has("google_error") || !params.get("google_code") || !attempt?.verifier) {
        throw new Error(tr("Accesso Google non completato o scaduto. Riprova dallo stesso browser."));
      }
      const data = await googleExchange(params.get("google_code"), attempt.verifier);
      sessionStorage.removeItem(GOOGLE_ATTEMPT);
      const journeyParams = new URLSearchParams();
      if(data.service)journeyParams.set('service',data.service);
      if(data.studio_slug===attempt?.studioSlug && /^GC-[0-9A-F]{32}$/i.test(attempt?.gift||''))journeyParams.set('gift',attempt.gift);
      if(data.studio_slug===attempt?.studioSlug && /^[a-z0-9-]{1,100}$/i.test(attempt?.campaign||""))journeyParams.set("campaign",attempt.campaign);
      if(data.studio_slug===attempt?.studioSlug)for(const key of ["brand","professional","service_type"]){
        const value=attempt?.[key]||"";
        if(/^[a-z0-9_:-]{1,160}$/i.test(value))journeyParams.set(key,value);
      }
      const search = journeyParams.size ? `?${journeyParams}` : '';
      if (data.registration_required) {
        sessionStorage.setItem(googleRegistrationKey(data.studio_slug), JSON.stringify({ ...data, expiresAt: Date.now() + 9 * 60 * 1000 }));
        nav(serviceJourneyUrl(data.studio_slug, "register", search), { replace: true });
      } else {
        nav(data.studio_slug ? serviceJourneyUrl(data.studio_slug, "client", search) : "/app", { replace: true });
      }
    })().catch(e => setError(errMsg(e)));
  }, [googleExchange, nav]);
  return <main className="min-h-screen grid place-items-center bg-zinc-950 p-6 text-white"><div className="max-w-md text-center">
    {error ? <><p role="alert">{systemText(error)}</p><a className="mt-4 inline-block underline" href={back}>{tr("Torna all'accesso")}</a></> : <><Loader2 className="mx-auto mb-4 h-8 w-8 animate-spin" /><p>{tr("Completamento accesso Google…")}</p></>}
  </div></main>;
}

